import {useSortableTable} from '@hm/fundamental'
import {useTranslation} from 'react-i18next'

import {ReportMaterialInstallationTableData} from '@refra/modules/refra-planning/types'

export const useKilnShutdownPrintConfig = () => {
  const {t} = useTranslation()

  return useSortableTable<ReportMaterialInstallationTableData>(
    [
      {
        id: 'refractoryName',
        label: t('refraPlanning.kilnShutdown.report.material')
      },
      {
        id: 'fromMeter',
        label: t('refraPlanning.kilnShutdown.report.fromMeter')
      },
      {
        id: 'toMeter',
        label: t('refraPlanning.kilnShutdown.report.toMeter')
      },
      {
        id: 'manufacturerName',
        label: t('refraPlanning.kilnShutdown.report.supplier')
      },
      {
        id: 'isMortarRequired',
        label: t('refraPlanning.kilnShutdown.report.mortar')
      },
      {
        id: 'format',
        label: t('refraPlanning.kilnShutdown.report.format')
      },
      {
        id: 'symbolKey',
        label: t('refraPlanning.kilnShutdown.report.symbolKey')
      },
      {
        id: 'pattern',
        label: t('refraPlanning.kilnShutdown.report.pattern')
      },
      {
        id: 'comments',
        label: t('refraPlanning.kilnShutdown.report.comment')
      }
    ],
    [],
    {
      prefix: 'refra_kiln_shutdown_report_table',
      postfixFieldName: 'cyPostfix'
    },
    {enableLocalSorting: true}
  )
}
